export function updateEarnedPoints(dispatch, currentPoints, { totalPoints, pointsGained } = {}) {
  // Prefer authoritative totalPoints when provided by the server
  if (typeof totalPoints !== 'undefined' && totalPoints !== null) {
    dispatch({ type: 'setEarnedPoints', payload: totalPoints });
    return;
  }

  // If only a delta is provided, add it to current context value (fallback)
  const base = typeof currentPoints === 'number' ? currentPoints : (currentPoints ? parseInt(currentPoints) : 0);
  if (typeof pointsGained !== 'undefined' && pointsGained !== null) {
    dispatch({ type: 'setEarnedPoints', payload: base + pointsGained });
    return;
  }
}

export default updateEarnedPoints;
